import React from "react";
import { Link } from "react-router-dom";
import { PawPrint, ArrowLeft } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div
      data-testid="not-found-page"
      className="flex min-h-screen items-center justify-center bg-slate-50 p-4"
    >
      <Card className="w-full max-w-md rounded-3xl shadow-md">
        <CardContent className="p-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-900 text-white">
            <PawPrint size={26} />
          </div>
          <p className="text-sm font-semibold uppercase tracking-wide text-slate-500">404</p>
          <h1 className="mt-1 text-2xl font-bold tracking-tight">Page not found</h1>
          <p className="mt-2 text-slate-600">
            That page wandered off. Let's get you back to your dogs.
          </p>
          <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-center">
            <Link to="/">
              <Button className="w-full rounded-2xl sm:w-auto" data-testid="back-to-app-btn">
                <ArrowLeft size={16} className="mr-2" />
                Back to app
              </Button>
            </Link>
            <Link to="/intake">
              <Button variant="outline" className="w-full rounded-2xl sm:w-auto">
                Request a consultation
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
